module.exports = __webpack_public_path__ + "80da708235862c2373a45caf7d93ee7d.png";